import Select, { components } from 'react-select';

// Multi-select with a checkbox per option and a "Select All" row, built on the same
// react-select setup HistoricalDashboard.js uses (checkbox Option, menu kept open,
// selected options kept visible, "react-select" class prefix for the shared styles).
// `value` / `onChange` work with plain option values, not option objects.

const SELECT_ALL = '__select_all__';

const CheckboxOption = (props) => (
  <components.Option {...props}>
    <input type="checkbox" checked={props.isSelected} onChange={() => null} className='react-select-checkbox' style={{ marginRight: 8 }} />
    <span className="checkbox-label">{props.label}</span>
  </components.Option>
);

// "Select All" is only a menu row; don't render it as a chip in the control.
const MultiValue = (props) => (props.data.value === SELECT_ALL ? null : <components.MultiValue {...props} />);

// The menu is portalled to <body> so a surrounding modal can't clip it; the modal
// overlay is z-index 10000 and toasts are 10010, so the menu sits between them.
const portalStyles = { menuPortal: (base) => ({ ...base, zIndex: 10005 }) };

function CheckboxMultiSelect({ options, value, onChange, inputId, placeholder, selectAllLabel = 'Select All', isLoading }) {
  const selectAllOption = { value: SELECT_ALL, label: selectAllLabel };
  const selected = options.filter((o) => value.includes(o.value));
  const allSelected = options.length > 0 && selected.length === options.length;

  const handleChange = (next, actionMeta) => {
    if (actionMeta.option?.value === SELECT_ALL) {
      onChange(actionMeta.action === 'select-option' ? options.map((o) => o.value) : []);
      return;
    }
    onChange((next || []).filter((o) => o.value !== SELECT_ALL).map((o) => o.value));
  };

  return (
    <Select
      isMulti
      inputId={inputId}
      options={options.length > 0 ? [selectAllOption, ...options] : []}
      value={allSelected ? [selectAllOption, ...selected] : selected}
      onChange={handleChange}
      components={{ Option: CheckboxOption, MultiValue }}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      isLoading={isLoading}
      placeholder={placeholder}
      menuPortalTarget={document.body}
      styles={portalStyles}
      classNamePrefix="react-select"
    />
  );
}

export default CheckboxMultiSelect;
